import { Component, OnInit } from '@angular/core';
import { PagedResponseModel } from 'src/app/models/common/paged-response.model';
import { PagedSearchModel } from 'src/app/models/common/paged-search.model';
import { UserItemModel } from 'src/app/models/user/user-item.model';
import { ApiService } from 'src/app/services/api.service';
import { BasePagedPage } from '../base-paged-page';
import { MessageService } from 'src/app/services/message.service';

@Component({
    selector: 'app-push-creator',
    templateUrl: './push-creator.component.html',
    styleUrls: ['./push-creator.component.scss'],
    standalone: false
})
export class PushCreatorComponent extends BasePagedPage<string, UserItemModel> implements OnInit {

  public model: {
    caption?: string;
    text?: string;
    sendAll?: boolean;
    users: Array<string>
  } = {
      users: [],
      sendAll: true
    };

  public constructor(private mApiService: ApiService, private mMessageService: MessageService) {
    super();
    this.isBusy = false;
  }

  ngOnInit(): void {
    this.getData(1);
  }

  public send() {
    this.isBusy = true;

    this.mApiService.post('api/admin/push', this.model).subscribe({
      next: () => {
        this.mMessageService.addMessage({
          text: 'Рассылка создана',
          type: this.mMessageService.types.success
        }, true);
        
        this.isBusy = false;
      },
      error: () => {
        this.isBusy = false;
      }
    })
  }

  public getData(page?: number | undefined): void {
    if (!page) { return; }

    this.isLoading = true;

    this.mApiService.getWithParams<PagedSearchModel<string>, PagedResponseModel<UserItemModel>>('/api/admin/user/manager/list', {
      page: page ?? 1,
      pageSize: this.pageSize,
      search: this.search
    }).subscribe({
      next: r => {
        this.items = r.items;

        this.page = page;
        this.pages = r.pages;

        this.isLoading = false;
      },
      error: () => this.isLoading = false
    });
  }

  public isUserAdded(id: string) {
    return this.model.users.indexOf(id) > -1;
  }

  public addUser(id: string) {
    this.model.users.push(id);
  }

  public removeUser(id: string) {
    this.model.users.splice(this.model.users.indexOf(id), 1);
  }

  public clearSelectedList() {
    if (confirm('Очистить список?')) {
      this.model.users = [];
    }
  }
}
